module.exports = __webpack_public_path__ + "img/close.e6efdea7.svg";